export default __webpack_public_path__ + "static/media/spinner-bg-2.b22b34c7.svg";